import { Container } from "../container";
import * as masterService from "../services/master/master-service";
import * as accessRights from "../features/entitlement/services/access-rights-service";
import Auth from "../utils/auth";
import * as Loader from "../common/common";
export default class KYCProvider extends Container {
  state = {
    message: "",
    masters: [],
    departments: [],
    accessRights: [],
  };

  actions = {
    handleError: (response, err) => {
      if (err) {
        this.setState({
          message: err,
        });
      } else if (response && response.data.err) {
        this.setState({
          message: response.data.err,
        });
      }
    },

    setMasters: async () => {
      Loader.showLoader();
      let { response, err } = await masterService.getAllMasters();
      Loader.hideLoader();
      if (err) {
        this.setState({
          message: "Error: " + err,
        });
      } else if (response && response.data.err) {
        this.setState({
          message: "Error: " + response.data.err,
        });
      } else {
        this.setState({
          masters: response.data,
        });
      }
    },
    getMastersByGroup: (group) => {
      let masters =
        this.state.masters && this.state.masters[group]
          ? this.state.masters[group]
          : [];
      return masters;
    },
    setDepartments: async () => {
      Loader.showLoader();
      let { response, err } = await masterService.getDepartments();
      Loader.hideLoader();
      if (err) {
        this.setState({
          message: "Error: " + err,
        });
      } else if (response && response.data.err) {
        this.setState({
          message: "Error: " + response.data.err,
        });
      } else {
        this.setState({
          departments: response.data,
        });
      }
    },
    setUserTypes: async () => {
      Loader.showLoader();
      let { response, err } = await masterService.getDepartments();
      Loader.hideLoader();
      if (err) {
        this.setState({
          message: "Error: " + err,
        });
      } else if (response && response.data.err) {
        this.setState({
          message: "Error: " + response.data.err,
        });
      } else {
        this.setState({
          departments: response.data,
        });
      }
    },
    setAccessRights: async () => {
      let userId = Auth.get("userId");
      Loader.showLoader();
      let { response, err } = await accessRights.getAccessRightsById(userId);
      Loader.hideLoader();
      if (err) {
        this.setState({
          message: "Error: " + err,
        });
      } else if (response && response.data.err) {
        this.setState({
          message: "Error: " + response.data.err,
        });
      } else {
        this.setState({
          accessRights: response.data,
        });
      }
    },
  };
  render() {
    return super.render();
  }
}
